export enum ItemTypes {
    PREVIEW_CARD = "PREVIEW_CARD",
}
